import { getOrderPayload } from './cart'

export default (tracker) => ({
  async applied(order, coupon) {
    await tracker.track('Coupon Applied', {
      ...(await getOrderPayload(order)),
      submitted_coupon_code: coupon,
    })
  },

  async removed(order) {
    await tracker.track('Coupon Removed', await getOrderPayload(order))
  },

  async denied(order, coupon) {
    await tracker.track('Coupon Denied', {
      ...(await getOrderPayload(order)),
      submitted_coupon_code: coupon,
    })
  },
})
